let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cHZvW")).then(() => parcelRequire('dvrex'));